import type {
  CreateUploadEndpointV1ConversationsConversationIdUploadsPostApiArg,
  CreateUploadEndpointV1ConversationsConversationIdUploadsPostApiResponse,
} from '~/api/hermes/typedefs.autogen';
import type { WithRtkOpts } from '~/redux/api/types';

import { endpoints as autogenEnhancements } from '~/api/hermes/enhancements.autogen';

import { hermesApiRoot } from './root';

hermesApiRoot.enhanceEndpoints({ endpoints: autogenEnhancements });

type CreateUploadApiArg = Omit<
  CreateUploadEndpointV1ConversationsConversationIdUploadsPostApiArg,
  'bodyCreateUploadEndpointV1ConversationsConversationIdUploadsPost'
> & {
  bodyCreateUploadEndpointV1ConversationsConversationIdUploadsPost: {
    file: Blob;
  };
};

/**
 * @lintignore Not imported by name anywhere, but this export must exist: dropping it
 * (or knip's fix un-exporting/deleting it) risks the module never being evaluated, which
 * would mean `injectEndpoints` never registers these endpoints on the shared root api.
 */
export const hermesApi = hermesApiRoot.injectEndpoints({
  overrideExisting: true,
  endpoints: (build) => ({
    createUploadEndpointV1ConversationsConversationIdUploadsPost:
      build.mutation<
        CreateUploadEndpointV1ConversationsConversationIdUploadsPostApiResponse,
        WithRtkOpts<CreateUploadApiArg>
      >({
        query: ({
          conversationId,
          bodyCreateUploadEndpointV1ConversationsConversationIdUploadsPost,
          rtkQueryOptions,
        }) => {
          const formData = new FormData();
          formData.append(
            'file',
            bodyCreateUploadEndpointV1ConversationsConversationIdUploadsPost.file,
          );

          return {
            url: `/v1/conversations/${conversationId}/uploads`,
            method: 'POST',
            body: formData,
            rtkQueryOptions,
          };
        },
      }),
  }),
});
